
"use client"

import * as React from "react"
import { ThemeProvider as NextThemesProvider } from "next-themes"
import { type ThemeProviderProps } from "next-themes/dist/types"

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  // Force document to respect the theme immediately on mount
  React.useEffect(() => {
    // Get stored theme or default to system
    const storedTheme = localStorage.getItem("socialsync-theme")
    
    // Apply theme class immediately to prevent flash of incorrect theme
    if (storedTheme === "dark" || 
        (!storedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      document.documentElement.classList.add("dark")
      document.body.style.backgroundColor = "hsl(222, 47%, 11%)"
    } else {
      document.documentElement.classList.remove("dark")
      document.body.style.backgroundColor = "#FAFBFD" // Set to our new pastel blue light
    }
    
    // Log theme application for debugging
    console.log("Theme applied on mount:", 
      document.documentElement.classList.contains("dark") ? "dark" : "light")
  }, [])

  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange={false}
      storageKey="socialsync-theme"
      {...props}
    >
      {children}
    </NextThemesProvider>
  )
}
